import getApiClient from "./../../../../shared/api";
import { connection } from "../../../../middleware/messageSignalRMiddleware";
import { HubConnectionState } from "@microsoft/signalr";

export const FETCH_AVAILABILITY = "FETCH_AVAILABILITY";
export const UPDATE_PERSON_AVAILABILITY = "UPDATE_PERSON_AVAILABILITY";
export const UPDATE_ALL_AVAILABILITY = "UPDATE_ALL_AVAILABILITY";
export const CLEAR_UPDATED_PEOPLE = "CLEAR_UPDATED_PEOPLE";

export function fetchAvailability(filmId, refetch) {
  if (connection.state === HubConnectionState.Disconnected) {
    connection.start().then(() => connection.invoke('SubscribeToFilm', filmId));
  }

  return (dispatch) => {
    dispatch({
      type: FETCH_AVAILABILITY,
      payload: getApiClient().get(`/film/${filmId}/scheduling/availability`),
      meta: { refetch }
    });
  };
}

export function updateAvailability(filmId, updatedPeople, actorsAvailability, backgroundActorsAvailability, crewMemberAvailability, locationsAvailability) {
  return (dispatch) => {
    // Filter each array to only include people that have been updated
    const updatedActors = actorsAvailability.filter(actor =>
      updatedPeople.has(`actor-${actor.id}`)
    );
    const updatedBackgroundActors = backgroundActorsAvailability.filter(backgroundActor =>
      updatedPeople.has(`background-actor-${backgroundActor.id}`)
    );
    const updatedCrew = crewMemberAvailability.filter(crewMember =>
      updatedPeople.has(`crew-${crewMember.id}`)
    );
    const updatedLocations = locationsAvailability.filter(location =>
      updatedPeople.has(`location-${location.id}`)
    );

    const availability = {
      actorsAvailability: updatedActors,
      backgroundActorsAvailability: updatedBackgroundActors,
      crewMemberAvailability: updatedCrew,
      locationsAvailability: updatedLocations
    };

    dispatch({
      type: UPDATE_ALL_AVAILABILITY,
      payload: getApiClient().put(`/film/${filmId}/scheduling/availability`, availability),
    });
  };
}

export const updatePersonAvailability = (personType, personId, date, isAvailable) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PERSON_AVAILABILITY,
      meta: { personType, personId, date, isAvailable }
    });
  };
};

export const clearUpdatedPeople = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_UPDATED_PEOPLE
    });
  };
};
